import { createSlice } from "@reduxjs/toolkit";

// define state here
const initialState = {
  data: [],
  totalRecords: 0,
  totalSize: 0,
  isFetching: false,
  error: null,
};

const getSafeFileSize = (value) => {
  const size = Number(value);
  return Number.isFinite(size) ? size : 0;
};

export const cartData = createSlice({
  name: "cartData",
  initialState,
  reducers: {
    fetchDataBegin: (state) => {
      state.isFetching = true;
      state.error = null;
    },
    fetchDataError: (state, action) => {
      state.isFetching = false;
      state.error = action.payload;
      state.data = [];
      state.totalSize = 0;
    },

    addCartSuccess: (state, action) => {
      const { newData } = action.payload;
      if (Array.isArray(newData)) {
        state.data = [...newData, ...state.data];
      } else {
        state.data.unshift(newData);
      }
      state.totalSize = state.data.reduce(
        (sum, item) => sum + getSafeFileSize(item.fileSize),
        0
      );
      // Update the totalSize count
      state.totalRecords = state.data.length;
      state.isFetching = false;
    },

    getCartSuccess: (state, action) => {
      const { newData } = action.payload;
      state.isFetching = false;
      state.data = newData.data;
      state.totalSize = Number.isFinite(Number(newData.totalSize))
        ? Number(newData.totalSize)
        : newData.data.reduce(
            (sum, item) => sum + getSafeFileSize(item.fileSize),
            0
          );
      state.totalRecords = newData.data.length;
    },

    removeCartSuccess: (state, action) => {
      const { files, clear } = action.payload;
      if (Array.isArray(files) && files.length > 0) {
        state.data = state.data.filter((item) => !files.includes(item.id));
      } else if (clear) {
        state.data = [];
      }
      state.totalRecords = state.data.length;
      state.totalSize = state.data.reduce(
        (sum, item) => sum + getSafeFileSize(item.fileSize),
        0
      ); // Recalculate total size
      state.isFetching = false;
    },
  },
});

export const {
  fetchDataBegin,
  fetchDataError,
  addCartSuccess,
  getCartSuccess,
  removeCartSuccess,
} = cartData.actions;

export const companyDataSelector = (state) => state.cartData.data;

export default cartData.reducer;
